const TOGGLE_CLASS = 'is-shown';
const DEFAULT_OPEN_CLASS = 'default-open';

function initCollapsibleSection(toggle) {
  const sectionParent = toggle.closest('[data-js-bind="collapsible-section"]');
  const controlledPanel = document.querySelector(
    `#${toggle.getAttribute('aria-controls')}`
  );
  
  const closeOtherAccordionSection = () => {
    const expandedToggle = document.querySelector(
      '[data-js-bind="collapsible-toggle"][aria-expanded="true"]'
    );
    const expandedPanel = document.querySelector(
      '.is-shown[data-js-bind="collapsible-panel"]'
    );

    if (!expandedToggle || !expandedPanel) return;

    expandedToggle.setAttribute('aria-expanded', false);
    expandedPanel.classList.remove(TOGGLE_CLASS);
    expandedPanel.classList.remove(DEFAULT_OPEN_CLASS);
  };

  const toggleSection = () => {
    const collapsibleAllToggle = document.querySelector(
      '[data-js-bind="collapsible-all-toggle"]'
    );
    const expandedToggles = [...document.querySelectorAll(
        `[data-js-bind="collapsible-toggle"]`
    )];
    const expanded = toggle.getAttribute('aria-expanded') === 'true' || false;

    if (toggle.getAttribute('data-accordion') === 'true') {
      closeOtherAccordionSection();
    }

    toggle.setAttribute('aria-expanded', !expanded);
    controlledPanel.classList.toggle(TOGGLE_CLASS, !expanded);
    controlledPanel.classList.remove(DEFAULT_OPEN_CLASS);

    if (!expanded && toggle.dataset.scrollIntoView === 'true') {
      toggle.parentNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (collapsibleAllToggle) {
      expandedToggles.some((expandedToggle) => {
        return expandedToggle.getAttribute('aria-expanded') === 'true';
      })  ? collapsibleAllToggle.textContent = "Alles inklappen" : collapsibleAllToggle.textContent = "Alles uitklappen";
    }
  };

  if (window.location.hash === `#${sectionParent.id}`) {
    toggleSection();
    toggle.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const toggleCollapsibleOnLoad = () => {
    if (!window.location.hash) return;
    const subject = document.querySelector(`div[data-js-bind="collapsible-section"]:has(div${window.location.hash})`);
    if (!subject || toggle.getAttribute('data-is-admin-menu') === 'true' ) return;

    const subjectToggle = subject.querySelector('[data-js-bind="collapsible-toggle"]');
    const subjectPanel = subject.querySelector('[data-js-bind="collapsible-panel"]');
    
    if (subjectToggle && subjectPanel) {
      subjectToggle.setAttribute('aria-expanded', true);
      subjectPanel.classList.add(TOGGLE_CLASS);
      subjectPanel.classList.remove(DEFAULT_OPEN_CLASS);

      // If the subject is a child of a collapsible section, expand the parent section
      const parent = subject.closest('[data-js-bind="collapsible-section"]');
      const parentToggle = parent.querySelector('[data-js-bind="collapsible-toggle"]');
      const parentPanel = parent.querySelector('[data-js-bind="collapsible-panel"]');

      if (parentToggle && parentPanel) {
        parentToggle.setAttribute('aria-expanded', true);
        parentPanel.classList.add(TOGGLE_CLASS);
        parentPanel.classList.remove(DEFAULT_OPEN_CLASS);
      }

      subject.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
  document.addEventListener('DOMContentLoaded', toggleCollapsibleOnLoad);
  toggle.addEventListener('click', toggleSection);

  // expose destroy method
  return () => {
    toggle.removeEventListener('click', toggleSection);
    document.removeEventListener('DOMContentLoaded', toggleCollapsibleOnLoad);
  };
}

const toggles = document.querySelectorAll('[data-js-bind="collapsible-toggle"]');
toggles.forEach((toggle) => {
  initCollapsibleSection(toggle);
});

module.exports = initCollapsibleSection;
